import { buildService } from './decorated-service';
import {
  StaticIndividualApplication,
  OptionalStaticIndividualApplication,
  IndividualApplication
} from '../../../core/types/applications/taxable-applications/individual-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';
import { setBenesBasedOnStateResidence } from '../../taxable-flows/shared/util';

const IndividualSubmissionApi = buildService(
  '/new-account-svc/service/v2/account/individual'
);

const FONASUIndividualSubmissionApi = buildService(
  '/new-account-svc/service/front-office/v2/account/individual'
);

export const IndividualApplicationService = (
  args: OptionalStaticIndividualApplication,
  consumerName
): Promise<any> => {
  const validated: StaticIndividualApplication = IndividualApplication.check(
    args
  );
  // remove benes from the payload if the state of residence is LA
  const payload = setBenesBasedOnStateResidence(validated);
  const submissionPayload = purgeEmptyFields(payload);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint =
    consumerName === consumerTypes.FONASU
      ? FONASUIndividualSubmissionApi
      : IndividualSubmissionApi;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
